import { useState } from 'react'
import { AuthForm, AuthFormState } from '@knots/shared-frontend'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { knotsApiSdk } from '@/lib/fetcher'
import { toastSuccess } from '@/utils/toast'
import { AuthLayout, NoAccount } from '@/features/auth'
import { LoadingOverlay } from '@/components/ui/Loaders'
import { defaultUtmSource } from '@/config'

export const Forgot = () => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className="auth-route">
      <AuthLayout
        title={t('auth.signin.title')}
        content={
          <AuthForm
            knotsApiSdk={knotsApiSdk}
            state={AuthFormState.Forgot}
            onError={() => {}}
            switchToLogin={() => {
              navigate({ pathname: '/auth/login', search: location.search })
            }}
            onResetSent={() => {
              toastSuccess(t('auth.forgot.alert.requestSuccess'))
            }}
            location={location}
            onLoading={setLoading}
            source={defaultUtmSource}
          />
        }
        footer={<NoAccount />}
      />
      <LoadingOverlay loading={loading} />
    </div>
  )
}
